// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","header":"header-1X6t_","saveButton":"saveButton-3o0Rg","group__field":"group__field-2ryYU"};